<template>
    <div class="progress">
        <div v-for="(value, index) in answer"
             :key="index"
             class="progress-bar"
             :class="classByValue(value)"
             role="progressbar"
             :style="{ width: (100 / answer.length) + '%'}">
        </div>
    </div>
</template>

<script>
export default {
    name: "MatAnswerProgress",
    props: {
        answer: Array
    },
    methods: {
        classByValue(value) {
            switch (value) {
                case 1:
                    return 'bg-success';

                case 0:
                    return 'bg-secondary';

                case -1:
                    return 'bg-danger';

                default:
                    return 'bg-light';
            }
        }
    }
}
</script>

<style scoped>

</style>